import { IInventoryUniqueItem } from './IInventoryUniqueItem';

export interface IInventoryDetailUniqueItem {
  inventoryCountDetailUniqueItemId: string;
  inventoryCountDetailId: string;
  uniqueItemId: string;
  uniqueItem: IInventoryUniqueItem;
  isBroken: boolean;
  isActive: boolean;
  isFound: boolean;
  isPulled?: boolean;
  isReturned?: boolean;
  modifiedBy: string;
  modifiedDate: string;
  countNotes?: string;
}
